/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-22",
    versionChannel: "nightly",
    buildDate: "2023-06-22T00:19:19.435Z",
    commitHash: "fe481144142cda39b9ef27653f6b13a9853b93fa",
};
